/* Quantity stepper on product cards (trash = decrease, plus = increase).
   Event delegation so it works for dynamically loaded cards too. */
(function () {
  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    if (!minus && !plus) return;

    var stepper = (minus || plus).closest('[data-qty-stepper]');
    if (!stepper) return;
    var input = stepper.querySelector('input[name="quantity"]');
    if (!input) return;

    var value = parseInt(input.value, 10);
    if (isNaN(value) || value < 1) value = 1;
    value = plus ? value + 1 : Math.max(1, value - 1);
    input.value = value;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
